<template>
  <main>
    <header class="banner row hvcenter text-white">
      <div class="backdrop">
        <div class="overlay"></div>
        <img :src="require('@/assets/images/banner_home.jpg')" alt="" />
      </div>
      <div class="container">
        <div class="welcome-card card text-center">
          <div class="card-content">
            <h2>Welcome to <b>CurioTravels</b></h2>
            <span>
              Your one stop shopping for everything African.<br />
              You can view our products and services by clicking below.
            </span>
          </div>
          <div class="card-action text-center">
            <router-link :to="{ name: 'Home' }" class="btn mr-3"> Products </router-link>
            <router-link :to="{ name: 'Itineraries' }" class="btn"> Services </router-link>
          </div>
        </div>
      </div>
    </header>
    <main>
      <div class="row container dealings">
        <div class="sm-12 mb-3 card">
          <div class="card-content">
            <div class="text-center">
              <h1 class="card-title">DEALINGS</h1>
            </div>
          </div>
        </div>
        <div class="col md-8 sm-12">
          <span class="text-justify">
            <h2 class="text-capitalize">Welcome to curio-city.</h2>
            <p>
              We are here to curate your ideas to life, both travel experiences
              & unique merchandise. We are proud of our heterogenous Kenyan
              culture and strive to include our clients in the creation process
              of all our products & services.
            </p>
            <p>
              We exclusively work with elderly locals who exquisitely handcraft
              each piece to suit your taste...
            </p>
            <p>
              Curious about our beautiful, scenic views and diverse culture?
              Send us a message and be sure we will deliver! :)
            </p>
            <!-- <p>
              Curate your ideas with us,as an item or travel. We boast of our
              heterogeneous culture and showcase that in our products while we
              allow our clients to be creative and part of the process. We
              partner with elderly men and women who are a major contributor to
              the team.
            </p>
            <p>
              Want to enjoy our beautiful scenic views and learn cultures
              hands-on, share what you have in mind and we shall deliver.
            </p> -->
            <p>
              #HappyShopping<br />
              #HappyTravels
            </p>
          </span>
        </div>
        <div class="col pl-3 md-4 hide-on-mobile">
          <div class="slideshow">
            <div class="slides">
              <div v-for="(pic, index) in dealingImages" :key="index" class="slide"
                :class="index === 0 ? 'active' : null">
                <div class="img">
                  <img :src="pic" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="featured-products row hcenter container">
        <div class="row hcenter">
          <h1>Featured Products</h1>
        </div>
        <div class="row">
          <product-card v-for="(product, index) in featuredProducts" :key="index" :product="product"
            class="sm-12 md-6 lg-4 pl-2 pr-2 mb-3" />
        </div>
        <div class="row hcenter mt-2">
          <div class="special-button">
            <button @click.prevent="$router.push({ name: 'Home' })">
              view more
            </button>
          </div>
        </div>
      </div>

      <div class="container gallery">
        <div class="text-center">
          <h1>Gallery</h1>
        </div>

        <div class="row pictures">
          <div v-for="(pic, index) in galleryImages" :key="index" class="lg-3 md-4 sm-12">
            <PictureFrame :image="pic" />
          </div>
        </div>

        <!-- <div class="row hcenter mt-3 action">
            <div class="special-button">
              <button class="waves">view all</button>
            </div>
          </div> -->
      </div>
    </main>

    <cart-button />
  </main>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import ProductCard from "@/components/product/ProductCard.vue";
import CartButton from "@/components/product/CartButton.vue";
import PictureFrame from "./components/PictureFrame";

export default {
  name: "Home",
  components: {
    PictureFrame,
    ProductCard,
    CartButton,
  },
  computed: {
    ...mapGetters({
      featuredProducts: "Products/getFeatured",
    }),
  },
  data() {
    return {
      dealingImages: [
        require("@/assets/images/dealing_travel.jpg"),
        require("@/assets/images/dealing_curio.jpg"),
        require("@/assets/images/dealing_real_estate.jpg"),
      ],
      galleryImages: [
        require("@/assets/images/tmp/gallery_1.jpg"),
        require("@/assets/images/tmp/gallery_2.jpg"),
        require("@/assets/images/tmp/gallery_3.jpg"),
      ],
    };
  },
  beforeCreate() {
    this.$store.dispatch("Products/getAll");
  },
  mounted() {
    window.addEventListener("scroll", this.handleWindowScroll, false);
    T.slideshow(".slideshow", 10000);
    T.waves();

    this.handleWindowScroll();
  },
  destroyed() {
    const navbar = document.querySelector("nav");
    navbar.classList.remove("translucent");

    window.removeEventListener("scroll", this.handleWindowScroll, false);
  },
  methods: {
    handleWindowScroll() {
      const offset = window.pageYOffset;
      const navbar = document.querySelector("nav");

      if (offset >= 560) navbar.classList.remove("translucent");
      else navbar.classList.add("translucent");
    },
    revealSearch() {
      const left = this.$refs.left;
      const right = this.$refs.right;
      const searchContainer = this.$refs["search-container"];

      left.style.opacity = 0;
      right.style.opacity = 0;

      setTimeout(() => {
        left.style.display = "none";
        right.style.display = "none";
        searchContainer.style.display = "block";
        // searchContainer.style.opacity = 1

        setTimeout(() => (searchContainer.style.opacity = 1), 10);
      }, 500);
    },
    hideSearch() {
      const left = this.$refs.left;
      const right = this.$refs.right;
      const searchContainer = this.$refs["search-container"];

      searchContainer.style.opacity = 0;

      setTimeout(() => {
        searchContainer.style.display = "none";
        left.style.display = "flex";
        right.style.display = "flex";

        setTimeout(() => {
          left.style.opacity = 1;
          right.style.opacity = 1;
        }, 100);
      }, 500);
    },
    // showSearchElements(left, right, searchContainer) {
    //   left.style.opacity = 0
    //   left.style.display = 'none'
    //   right.style.opacity = 0
    //   right.style.display = 'none'

    //   searchContainer.style.display = 'block'
    //   searchContainer.style.opacity = 1
    // }
  },
};
</script>

<style lang="scss" scoped>
$color: #f3eee8;

.container {
  @media only screen and (min-width: 992px) {
    padding: 0 15%;
  }
}

.special-button {
  width: max-content;
  padding: 8px;
  border-radius: 5px;
  background: linear-gradient(#aa9d8d, #ffffff);
}

.content {
  width: 100%;
}

.left,
.center,
.right {
  transition: all 0.25s linear;
  background-color: transparent;
}

@media only screen and (max-width: 600px) {
  .center {
    opacity: 0;
    display: none;

    input {
      padding-left: 10px;
      padding-right: 12px;
    }
  }
}

// end of separation

.banner {
  height: 90vh;
  position: relative;

  .overlay {
    background: rgba(91, 42, 2, 0.781);
  }

  .welcome-card {
    background-color: rgba(0, 0, 0, 0.55);

    @supports ((backdrop-filter: blur(20px))) {
      backdrop-filter: blur(20px);
      border: 1px solid #ffffff29;
    }

    h2 {
      font-size: 2rem;
      margin-bottom: 20px;
    }

    span {
      font-size: 1rem;
      opacity: 0.7;
    }

    .card-action {
      background-color: transparent;
    }
  }
}

.dealings {
  margin-top: -60px;
  padding-bottom: 50px;
  background-color: transparentize($primary-color, 0.9) !important;

  p {
    opacity: 0.75;
  }

  .slideshow {
    border-radius: 8px;
    overflow: hidden;

    img {
      height: 220px;
    }
  }
}

.featured-products {
  margin: 4rem 0;

  h1 {
    margin-top: 0;
  }
}

footer,
.gallery {
  background-color: transparentize($primary-color, 0.95) !important;
}

.gallery {
  padding-top: 20px;
  padding-bottom: 100px;
  // background-color: #f3eee8;

  .pictures {
    row-gap: 3ch;
    justify-content: space-between;
  }

  .action {
    margin-top: 1rem;
  }
}
</style>

<style lang="scss">
.theme-dark {
  .special-button {
    background: linear-gradient(#00000060, #ffffff29);
  }
}
</style>